/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { LoadingBox, LoadingBoxProps } from '@jagex/design_runescape';
import React, { FunctionComponent } from 'react';
import { Container } from 'theme-ui';
import { ContentContainer, FlexContainer } from '@components/layouts';

export const Loader: FunctionComponent<Partial<LoadingBoxProps>> = ({ children, loading = true }) => (
  // @ts-expect-error TS2590: Expression produces a union type that is too complex to represent.
  <ContentContainer minWidth="25%" maxWidth="75%" data-testid="loader-container">
    <FlexContainer justifyContent="center" my={0} flexWrap="wrap">
      <Container>{children}</Container>
      <LoadingBox loading={loading} />
    </FlexContainer>
  </ContentContainer>
);
